// Placeholder until the App Store Custom Product Page exists: replace with the CPP's URL.
const APP_STORE_URL = 'https://apps.apple.com/app/id6766313661'

export type ContinueOnIphonePlacement = 'today_empty' | 'session_end'

// ct= is Apple's campaign token, splitting installs by placement. App Analytics also needs
// pt=<provider token>&mt=8, which comes from App Store Connect.
export function continueOnIphoneHref(placement: ContinueOnIphonePlacement): string {
  const url = new URL(APP_STORE_URL)
  url.searchParams.set('ct', `web_${placement}`)
  return url.toString()
}
